export default{grid:"w_Ag",gutter:"w_Ah"};
